import React from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";

import { connect } from "react-redux";
import { BaseReactComponent } from "../../utils/form";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ALT_THUMBNAIL, API_LIMIT, START_PAGE, isModuleExist } from "../../utils/Constant";
import { InformationModal, ComponentHeader, Spinner, VerifiedModal } from "../common";
import { getAllSsoContentApi } from "./Api";
import { replaceHistory } from "../../utils/ReusableFunctions";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { toast } from "react-toastify";
import { deleteAuthCommonApi } from "../content/Api";
import editPencil from "../../assets/images/edit-icon.png";
import { CONTENT_VERIFY } from "../../utils/urls";
import { withRouter } from "../../utils/hoc/withRouter";

class SsoContent extends BaseReactComponent {
    constructor(props) {
        super(props);
        const AccesData = isModuleExist("Sso", 'Content');
        this.state = {
            access: AccesData,
            search: "",
            dummyData: [],
            searchResult: [],
            pageSize: API_LIMIT,
            currentPage: START_PAGE,
            delete: false,
            deleteData: {},
            editData: "",
            showEdit: false,
            isLoading: true,

            isVerify: false,
            show: false,

            verified: '',
            verifyUrl: ''
        };
    }

    componentDidMount() {
        const { history } = this.props;
        history({
            pathname: this.props.location.pathname,
            search: `?p=${this.state.currentPage || START_PAGE}`,
        });
        this.props.getAllSsoContentApi(this);
    }

    componentDidUpdate(prevProps, prevState) {
        const prevParams = new URLSearchParams(prevProps.location.search);
        const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
        const prevSearch = prevParams.get("search") || "";
        const prevVerified = prevParams.get("isVerified") || "";

        const params = new URLSearchParams(this.props.location.search);
        const page = parseInt(params.get("page"), 10) || START_PAGE;
        const search = params.get("search") || "";
        const verified = params.get("isVerified") || "";

        if (prevPage !== page || prevSearch !== search || prevVerified !== verified) {
            this.setState({ currentPage: page, search }, () => {
                this.props.getAllSsoContentApi(this);
            });
        }
    }
    onChangeMethod = (value) => {
        this.setState({ searchText: value.search, currentPage: START_PAGE }, () => {
            replaceHistory(this.props.history, START_PAGE, value.search);
        })
    };
    clearSearch = () => {
        this.onChangeMethod({ search: "" });
    }

    getDetailsUser = (data) => {
        this.props.history({ pathname: `/sso/content-details/${data?.uuid}`, state: { "id": data?.uuid } });
    }
    showEditModal = (rowData = null) => {
    this.props.history({ pathname: "/content/add-content", state: { id: rowData.uuid } });
    // this.setState({
    //   showEdit: !this.state.showEdit,
    //   editData: rowData,
    // });
  };
   openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
   deleteHandle = async (id) => {
      const res = await deleteAuthCommonApi(`content/${id}`);
      // console.log(res)
      if (res.status === 200) {
        this.props.getAllSsoContentApi(this);
        this.setState({
          delete: !this.state.delete
        });
        // toast.success("Successfully Deleted.")
      } else {
        toast.error("Somthis wrong...")
      }
      // deleteAmcApi(id, this, this.openCloseDeleteModal) updat this
    }
    render() {
        const { dummyData, search, serchResult, tabName, activeTab, access, isLoading } = this.state;
        const { ssoContentList, totalPages, currentPage } = this.props.ssoContentEventState;

        const admin = JSON.parse(localStorage.getItem("finAdmin"))?.user || {};
        // console.log('from action reduction list', contentList)
        return (
            <>
                {this.state.delete && (
                    <InformationModal
                        show={this.state.delete}
                        id={this.state.deleteData.uuid}
                        title={`Are you sure you want to delete ${this.state.deleteData.title}?`}
                        handleClose={this.openCloseDeleteModal}
                        handleDelete={this.deleteHandle}
                    />
                )}
                 <VerifiedModal
                          // name={`this '${this.state.editData?.campaignName}' campaign.`}
                          name={`'${this.state.editData?.title}'`}
                          show={this.state.show}
                          url={CONTENT_VERIFY + `/${this.state?.editData?.uuid}`}
                          isVerified={this.state.isVerify}
                          handleCancel={() => { this.setState({ show: false }) }}
                          successRes={() => { this.props.getAllSsoContentApi(this) }}
                        />

                <section className="request-section">
                    <ComponentHeader
                        title="Content"
                        isSearch={true}
                        placeholder={"Search Content"}
                        onChangeMethod={this.onChangeMethod}
                        clearSearch={() => this.clearSearch()}
                        primaryBtn={access?.createAccess ? "Add Content": null}
                        handlePrimaryBtn={() => {
                            this.props.history("/content/add-content");
                        }}
                    />
                    <div className="">
                        <Row>

                            <Col sm={2}>
                                <FilterVefiedDropDown ctx={this} />
                            </Col>
                        </Row>
                    </div>
                    <div className="commom-table-wrapper">
                        <CustomTable
                            data={isLoading ? [] : ssoContentList?.list || []}
                            columns={[

                                {
                                    width: 150,
                                    title: "Title",
                                    dataIndex: "title",
                                    className: "name",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "title") {
                                            return rowData?.title || '';
                                        }
                                    },
                                },
                                {
                                    width: access.verificationAccess ? 80 : 0,
                                    title: "Verified",
                                    dataIndex: "verify",
                                    className: "name",
                                    // isFilter:true,
                                    // handleSortByCol:()=>console.log("sort aplycable"),
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "verify") {

                                        return <div className=" d-flex align-items-center inter-medium">
                                            {(rowData.isVerified) ? "Yes" : 'No'} 
                                            {(admin?.ssoPartnerId === rowData?.ssoPartnerId) && <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />}
                                        </div>;
                                        }
                                    },
                                },

                                {
                                    width: 150,
                                    title: "AMC",
                                    dataIndex: "amc",
                                    className: "name",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        // console.log(rowData?.amc ?? "happy")
                                        if (dataKey === "amc") {
                                            return rowData?.amc?.amcName || ''
                                        }
                                    },
                                },
                                {
                                    width: 150,
                                    title: "Content Type",
                                    dataIndex: "contentType",
                                    className: "name",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "contentType") {
                                            return rowData?.contentType?.contentTypeName || "";
                                        }
                                    },
                                },
                                {
                                    width: 150,
                                    title: "Thumbnail Image",
                                    dataIndex: "thumbnail",
                                    className: "",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "thumbnail") {
                                            return (rowData.thumbnail ? <Image src={rowData.thumbnail} className="table-img" alt={ALT_THUMBNAIL} /> : "NA");
                                        }
                                    },
                                },
                                {
                                    width: 150,
                                    title: "Category",
                                    dataIndex: "category",
                                    className: "name",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "category") {
                                            return rowData?.category?.categoryName || ''
                                        }
                                    },
                                },

                                {
                                    width: 80,
                                    title: "Liked",
                                    dataIndex: "Liked",
                                    className: "liked",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "Liked") {
                                            return rowData?.Liked;

                                        }

                                    },

                                },
                                {
                                    width: 130,
                                    title: "Downloaded",
                                    dataIndex: "Downloaded",
                                    className: "downloaded",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "Downloaded") {

                                            return rowData?.Downloaded;
                                        }

                                    },
                                },
                                {
                                    width: 100,
                                    title: "Shared",
                                    dataIndex: "Shared",
                                    className: "shared",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "shared") {

                                            return rowData?.Shared;
                                        }
                                        return '0';
                                    },
                                },
                                {
                                    width: 80,
                                    title: "Cobrand",
                                    dataIndex: "Cobrand",
                                    className: "cobrand",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "Cobrand") {
                                            return rowData?.Cobrand;

                                        }

                                    },
                                },
                                {
                                    width: 120,
                                    title: "Saved",
                                    dataIndex: "Saved",
                                    className: "saved",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "Saved") {
                                            return rowData?.Saved;

                                        }

                                    },
                                },
                                {
                                    width: 300,
                                    title: "Action",
                                    dataIndex: "",
                                    className: "",
                                    isCell: true,
                                    render:(text, rowData, dataKey) => {
                                        if (dataKey === "") {
                                            return (
                                                <>
                                                    <Button onClick={() => this.getDetailsUser(rowData)} className="primary-btn inter-medium f-s-14 lh-18 mr-5">
                                                        View Detail
                                                    </Button>
                                                    {access.updateAccess && (admin?.ssoPartnerId === rowData?.ssoPartnerId) && <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />}
                                                    {access.deleteAccess && (admin?.ssoPartnerId === rowData?.ssoPartnerId) && <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />}
                                                </>
                                            );
                                        }
                                    },
                                },
                            ]}
                            message="No data found" // For Pagination
                            history={this.props.history}
                            location={this.props.location}
                            total={totalPages}
                            currentPage={currentPage}
              loading={this.state.isLoading}
                        />
                        {isLoading ?
                            <div className="inter-medium f-s-18 lh-22 text-center py-5 d-flex align-items-center justify-content-center gap-12"> <Spinner classes={'black-border'} /> Loading...</div>
                            : (ssoContentList.length === 0) ?
                                <div className="inter-medium f-s-18 lh-22 text-center py-5"> Result is not found.</div> : ''
                        }
                    </div>
                </section>
            </>
        );
    }
}


const mapStateToProps = (state) => ({
    ssoContentEventState: state.SsoContentEventState,
});
const mapDispatchToProps = {
    getAllSsoContentApi,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SsoContent));
